import styled, { css } from 'styled-components';

const CommonHeaderStyles = css`
    margin: 0;
    padding: 0 0 1rem 0;
`;

export const H1 = styled.h1`
    ${CommonHeaderStyles}
`;

export const H2 = styled.h2`
    ${CommonHeaderStyles};
    font-size: 2rem;
    font-weight: bold;

    @media screen and (max-width: 720px) {
        font-size: 1.5rem;
    }
`;

export const H3 = styled.h3`
    ${CommonHeaderStyles}
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 120%;
`;

export const H4 = styled.h4`
    ${CommonHeaderStyles}
`;

export const H5 = styled.h5`
    ${CommonHeaderStyles}
`;

export const P = styled.p`
    ${CommonHeaderStyles};
    line-height: 130%;
    font-size: 1rem;
`;

export const Pre = styled.pre`
    margin: 0.5rem 0;
    padding: 0.5rem 1rem;
    border-radius: 0.2rem;
    font-size: 1rem;
    font-family: Menlo, Consolas, Monaco, Lucida Console, Liberation Mono,
        DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace;
    background-color: #000c;
`;

export const Button = styled.button`
    appearance: none;
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    font-size: inherit;
    outline: none;
`;
